
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drawings/[slug]",
      function () {
        return require("private-next-pages/drawings/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drawings/[slug]"])
      });
    }
  